import { styled, IconButton, Typography } from '@mui/material';

export const Title = styled('div')(() => ({
  display: 'flex',
  gap: 24,
}));

export const HeaderIconButton = styled(IconButton)(() => ({
  height: 'fit-content',
}));

export const SecondaryText = styled(Typography)(() => ({
  cursor: 'pointer',
}));
